export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/500-79355a181a1eec0fcaf288c9eb306093.png";